export const ALERT_BOX_TYPES = {
    INFO: '0',
    ALERT: '1'
}